import dashboard from './dashboard'
import appsAndPages from './cs-apps'
import uiElements from './approvals'
import formAndTable from './insights'

// Array of sections
export default [...dashboard, ...appsAndPages, ...uiElements, ...formAndTable]
